export default __webpack_public_path__ + "/dist/images/ai-powered-it.7f831d511fe14704a72c4b2cafec4a13.jpg";